import { render, staticRenderFns } from "./Artifacts.vue?vue&type=template&id=a06a95d0&"
import script from "./Artifacts.vue?vue&type=script&lang=js&"
export * from "./Artifacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports